import Service from "../../AuthService";
const factoryEmployeeExport = {
    getFactoryEmployeeExport(page,data){
        return Service.get(`/factory_employee_export?page=${page}` +
            `&factory_id=${data.factory_id}` +
            `&start_date=${data.start_date}` +
            `&end_date=${data.end_date}` +
            `&employee_id=${data.employee_id}`+
            `&pdf=${data.pdf}`
        );
    },
    showFactoryEmployeeExport(id){
        return Service.get('/factory_employee_export/'+id);
    },
    createFactoryEmployeeExport(data){
        return Service.post('/factory_employee_export',data);
    },
    updateFactoryEmployeeExport(id,data){
        return Service.put('/factory_employee_export/'+id,data);
    },
    deleteFactoryEmployeeExport(id){
        return Service.delete('/factory_employee_export/'+id);
    },
}
export default factoryEmployeeExport
